import gameState from "slotworks/model/game-state";
import RainbowStacksRespinRecord from "integration/revolver/schema/respin-record";
import State from "slotworks/state-machine/states/state";
import RSBigWinMediator from "mediators/big-win-mediator";
import Layers from "slotworks/graphics/layers/layers";
import campaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import Components from "slotworks/components/components";
import soundManager from "slotworks/sound/sound-manager";

export default class RSBigWins extends State {

    private onComplete: Function;

    public onEnter(cascadeScip: boolean) {
        const record = gameState.getCurrentGame().getCurrentRecord();

        if(gameState.getCurrentGame().inFreespinsGame || (record instanceof RainbowStacksRespinRecord && record.isJackpotWon)) {
            this.complete();
        } else {
            this.proceed(cascadeScip);
        }
    }

    private proceed(cascadeSkip: boolean) {
        if (!cascadeSkip) {
            const bigWinMediator = new RSBigWinMediator();

            this.onComplete = () => this.complete();

            const wasPromoVisible = Layers.PromoBetBar.container.visible;

            bigWinMediator.start().then((bigWin) => {
                if(wasPromoVisible && bigWin && campaignsModel.isFreespinsActive()) {
                    Layers.PromoBetBar.show();
                    Layers.SmartButton.show();
                }
                bigWinMediator.end();
                if (this.onComplete) {
                    this.onComplete();

                }
            });
        }

        const freespins = campaignsModel.freespins;
        if(freespins) {
            try {
                Components.promoBetBar.setTotalWin(freespins.totalWin);
            }catch(e) {

            }
        }
    }

    public onSkip(cascaded: boolean) {
        if (cascaded) {
            this.skip();
        } else {
            this.onComplete = () =>  this.skip();
        }
    }

    public onExit() {
        if(!gameState.getCurrentGame().inFreespinsGame)
            soundManager.customEvent("base_music_soft");
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/big-win.ts